import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const wrapper = css({
  position: 'relative',
})

export const button = css({
  blockSize: Spacing.L,
  inlineSize: Spacing.L,
})

export const input = css({
  height: Spacing.L + 2,
  position: 'absolute',
  top: 0,
  width: Spacing.L + 2,
  visibility: 'hidden',
})
